window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const buttons = gsap.utils.toArray(".klima-point");
    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => openTooltip(button));
      button.addEventListener("mouseleave", () => closeTooltip(button));
    });
  
    const openTooltip = (button) => {
      const pointInner = button.querySelector(".klima-point_inner");
      const pointInnerMessage = button.querySelector(
        ".klima-point_inner_message"
      );
      let mm = gsap.matchMedia();
  
      mm.add("(min-width: 768px)", () => {
        gsap.to(button, {
          scale: 4,
          duration: 0.3,
        });
        gsap.to(pointInner, {
          scale: 1.95,
          duration: 0.3,
        });
        gsap.to(pointInnerMessage, {
          scale: 0.15,
          display: "block",
          duration: 0,
        });
      });
      mm.add("(max-width:767px)", () => {
        gsap.to(button, {
          scale: 2.8,
          duration: 0.3,
        });
        gsap.to(pointInner, {
          scale: 1.95,
          duration: 0.3,
        });
        gsap.to(pointInnerMessage, {
          scale: 0.15,
          display: "block",
          duration: 0,
        });
      });
      button.classList.add("klima-point-open");
    };
  
    const closeTooltip = (button) => {
      const pointInner = button.querySelector(".klima-point_inner");
      const pointInnerMessage = button.querySelector(
        ".klima-point_inner_message"
      );
      gsap.to([button, pointInner], {
        scale: 1,
        duration: 0.3,
      });
      gsap.to(pointInnerMessage, { display: "none", duration: 0 });
      button.classList.remove("klima-point-open");
    };
  }, 500)
});